//////////////////////////////////////////////////////////////
// REPLAY SCREEN

import m from "mithril";
import dayjs from 'dayjs'
import {filesize} from 'filesize'
import {loadContent} from "../Api";

import {defineWidget, NoticeWidget} from "@nebularstreams/libmui"

import {STATE_REPLAY as STATE} from "../State";

import {RePlayer} from "./misc/RePlayer";
import {TitleBarWidget} from "./misc/TitleBarWidget";
import {ContentBrowser} from "./misc/ContentBrowser";
import {StreamCard} from "./misc/StreamCard";

//////////////////////////////////////////////////////////////

const {service: SERVICE} = STATE;

//////////////////////////////////////////////////////////////

/**
 * load the replays in bucket
 * @param streamname
 * @private
 */

function loadBucket(streamname) {


	if (STATE.streamname === streamname && STATE.content?.list?.length) {
		m.redraw();
		return;
	}

	STATE.loadingContent = true;
	m.redraw();
	loadContent(STATE_REPLAY, streamname, "m3u8")
		.then(() => {
			STATE.streamname = streamname;
		})
		.finally(() => {
			STATE.loadingContent = false;
			if (STATE.content?.list)
				STATE.content.list = STATE.content.list.sort((a, b) => new Date(a.date) < new Date(b.date) ? 1 : -1);
			m.redraw()
		});
}

//////////////////////////////////////////////////////////////
// UI WIDGETS


const

	// helper to run a playlist item from the file list
	runReplayItem = (item) => {

		const

			[stream1, stream2, maybeAbr, maybeTimestamp] = item.key.split("/").pop().split(".m3u8")[0].split("-"),

			session = maybeTimestamp
				? parseInt(maybeTimestamp, 10)
				: maybeAbr
					? parseInt(maybeAbr, 10)
					: null,

			computedStreamNameParts = maybeAbr === "abr"
				? [stream1, stream2, maybeAbr]
				: [stream1, stream2],

			computedStreamName = computedStreamNameParts.join("-");

		Object.assign(STATE, {
			replayStreamname: computedStreamName,
			session,
			currentItem: item
		});

		m.redraw();
	},


	// widget: The Bucket Item
	ContentItem = defineWidget(
		({attrs}) => m("li.flexrow.wm",
			{
				class: (STATE.currentItem === attrs.item) ? "selected" : "",
				onclick: () => {
					runReplayItem(attrs.item);
				}
			},
			[
				m("span.name.grows.ellipsis.ohidden", attrs.item.key),
				m("span.size.col-2", filesize(attrs.item.size)),
				m("span.date.col-2", dayjs(attrs.item.date).fromNow())
			])),


	// widget: Main Screen
	ReplayScreen = defineWidget(
		({attrs}) => [
			m(TitleBarWidget, {
				title: "Replay",
				rootTitle: "Studio",
				rootTitleClick: () => m.route.set(`/${attrs.orga}`)
			}),
			m(".flexcol.h-100.ohidden.grows", [

				m(StreamCard, {state: STATE, service: "replay", orga: attrs.orga, class: "firstlevel"}),

				// body
				m(".flexrow.ohidden.maincontainer", [

					...(STATE.content?.ts)
						? [
							m(".flexcol.grows.ohidden.part-left", [
								// bucket list
								m(ContentBrowser, {
									state: STATE,
									noUpload: true,
									title: "Your HLS Playlists in nanoStream Storage",
									emptyMessage: "No Replay sessions for this streamname",
									itemWidget: ContentItem
								})
							]),
						]
						: [],
					...STATE.replayStreamname || STATE.error
						? [
							m(".flexcol.part-right.grows", [

								...STATE.replayStreamname
									? [
										m(RePlayer, {
											key: STATE.replayStreamname + "-" + (STATE.session || ""),
											streamname: STATE.replayStreamname,
											session: STATE.session || "",
											title: STATE.session
												? "Broadcasted on " + new Date(STATE.session).toUTCString()
												: "Current or Last Session"
										})]
									: [],

								...STATE.error
									? [
										m(NoticeWidget, {
											class: "rednotice marg-2 grows",
											icon: "exclamation-triangle",
											text: STATE.error,
											title: "Click to dismiss",
											onClick: () => {
												if (STATE.errorFatal) delete STATE.streamname;
												delete STATE.error;
												m.redraw();
											}
										})
									] : []
							])
						]
						: []
				])
			])
		],
		({attrs}) => {

			STATE.service = SERVICE;

			document.title = "replay - nanoStream Studio"

			if (attrs.key) loadBucket(attrs.key);
			else if (STATE.streamname) m.route.set(`/${attrs.orga}/${SERVICE}/${STATE.streamname}`);
		}
	);

export default ReplayScreen;
